<template>
  <el-container>
    <el-header style="min-width:1360px" class="flex flex-v-center fixed flex-h-center header">

      <el-image @click="toIndex()" class="logo menu pointer" :src="logo" fit="cover"></el-image>
      <el-menu ref="topNav" :text-color="theme === 'dark' ? '#ffffff' : '#303030'" active-text-color="#E6A23C" router
        :default-active="active" mode="horizontal">
        <el-menu-item @click="toMain('PTE')" index="" class="menu bold  m-hover">
          <span>{{ $t('首页') }}</span>
        </el-menu-item>
        <el-submenu index="/main/pte" class="menu0 bold  m-hover">
          <template slot="title">
            <span @click="toMain('PTE')">{{ $t('PTE练习') }}</span>
          </template>
          <sort-panel></sort-panel>
        </el-submenu>


        <el-submenu v-if="$store.state.lang != 'en'" :class="{ 'active': active == '/media' }" index="/course"
          class="menu0 bold">

          <template slot="title"><span>{{ $t('PTE课程') }}</span></template>

          <el-menu-item :key="index" v-for="(course, index) in $store.getters.getCourses('PTE')"
            :index="'/media?tag=course&id=' + course.id" class="menu bold m-hover"
            style="font-size: 14px !important;">{{
              course.title }}</el-menu-item>

        </el-submenu>

        <el-menu-item v-if="$store.state.lang != 'en'" index="/article" class="menu bold  m-hover"><span>{{ $t('备考入门')
            }}</span></el-menu-item>

        <el-menu-item v-if="$store.state.lang != 'en'" @click="toMain('CCL')" index="/ccl"
          class="menu bold  m-hover"><span>CCL</span></el-menu-item>

      </el-menu>


      <search-input></search-input>

      <el-image @click="personal()" v-if="$store.state.user" style="width:50px; height: 50px;cursor: pointer;"
        fit="contain" class="radius-c" :src="avatar">
      </el-image>

      <!-- <el-menu text-color="#303030" v-if="$store.state.user" active-text-color="#E6A23C" mode="horizontal">
        <el-menu-item index="abc" @click="exit" class="menu1"><span class="tag">{{ $t('退出登录') }}</span></el-menu-item>
      </el-menu> -->

      <el-menu :text-color="theme === 'dark' ? '#ffffff' : '#303030'" v-else active-text-color="#E6A23C" router
        :default-active="active" mode="horizontal">
        <el-menu-item index="/login" class="menu1 bold m-hover"><span>{{ $t('登录') }}</span></el-menu-item>
        <el-menu-item class="menu2 no-cursor" style="border-bottom:none;color: #999 !important;">|</el-menu-item>
        <el-menu-item index="/regist" class="menu2  bold m-hover"><span>{{ $t('注册') }}</span></el-menu-item>
      </el-menu>
      <div class="margin-l" style="margin-top: 3px;">
        <core-dialog />
      </div>

      <div style="margin-top: 3px;">
        <language />
      </div>

      <div class="margin-l" style="margin-top: 3px;">
        <dark-mode-toggle />
      </div>

    </el-header>

    <el-main class="main">
      <router-view></router-view>
    </el-main>

    <c-footer v-if="footer"></c-footer>

  </el-container>
</template>

<script>
import cFooter from '../../components/CFooter.vue';
import coreDialog from '../../components/CoreDialog.vue';
import darkModeToggle from '../../components/DarkModeToggle.vue';
import language from '../../components/Language.vue';
import searchInput from '../../components/SearchInput.vue';
import sortPanel from '../../components/SortPanel.vue';

export default {
  components: {
    searchInput, cFooter, language, sortPanel, coreDialog, darkModeToggle
  },
  data: function () {
    return {
      active: "/",
      footer: true,
      search: "",
      menuOpened: false,
    }
  },

  computed: {

    logo: function () {
      return this.theme == "dark" ? "/web/image/logo-dark.png" : "/web/image/logo.png"
    },

    theme: function () {
      return this.$store.state.theme
    },

    pteMode: {
      get() {
        return this.$store.state.pteMode
      },
      set(val) {
        this.$store.commit('set_pte_mode', val)
      }
    },

    avatar: function () {
      if (this.$store.state.user && this.$store.state.user.avatar) {
        if (this.$store.state.user.avatar.indexOf('http') === 0) {
          return this.$store.state.user.avatar
        } else {
          return this.$host + this.$store.state.user.avatar
        }
      }
      return this.$host + '/web/image/logo0.png'
    }
  },
  watch: {
    $route(route) {
      this.active = route.path;
      if (route.path == "/login" || route.path == "/regist" || this.$route.query.immersive) {
        this.footer = false;
      } else {
        this.footer = true;
      }
    }
  },

  created() {
    // localStorage.setItem("theme", "light")
    this.$store.dispatch("fetch_courses")
    this.$bus.$on("toggle_menu", () => {

      if (this.$refs.topNav) {
        this.$refs.topNav.close("/main/pte");
        this.$refs.topNav.close("/main/ccl");
      }

    })

    this.active = this.$route.path
    if (this.active == "/login" || this.active == "/regist" || this.$route.query.immersive) {
      this.footer = false;
    }
  },
  methods: {

    personal() {
      this.$router.replace("/main/personal");
    },

    toMain(mode) {
      if (this.$store.state.user == null && mode == "PTE") {
        this.$router.replace("/");
      } else {
        this.$store.commit("setMode", mode);
        this.$refs.topNav.close("/main");
        this.$router.replace("/main");
      }
    },

    toIndex() {
      if (this.$route.path != "/") this.$router.replace("/")
    },
    exit() {
      this.$store.commit("setUser", null)
    },
  },
};
</script>

<style scoped>
.active>>>.el-submenu__title {
  color: #E6A23C !important;
  text-decoration: underline;
  text-underline-offset: 20px;
  text-decoration-thickness: 2px;
}


.logo {
  width: 100px;
}

.tag {
  color: #f66;
  line-height: 20px;
  padding: 5px 15px;
  display: inline-block;
  border-radius: 15px;
  border: 1px solid #f66;
}

.popnav {
  display: none;
  position: fixed;
  top: 80px;
  left: 0;
  right: 0;
}


.main {
  padding-top: 80px;
  }

.el-link.el-link--default:after {
  border-color: #ffffff;
}

.el-divider {
  background-color: #606266;
}


.menu {
  padding: 0;
  margin: 10px 20px;
}

.menu0 {
  padding: 0;
  margin: 10px 0;
}

.menu1 {
  padding: 0;
  margin-left: 30px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.menu2 {
  margin-top: 10px;
  margin-left: 15px;
  padding: 0;
}

.header>>>.el-input__inner {
  border-radius: 20px;
  background-color: #f0f0f0;
  border: none;
}

.el-menu--horizontal {
  left: 0 !important;
}
</style>
